import { useEffect } from 'react';

import { useMountEffect, usePrevious } from '@infinex/ui-utils/react';

type DialogTransitionProps = {
  children: React.ReactNode;
  isEntering: boolean;
  isExiting: boolean;
  onOpenComplete?: () => void;
  onCloseComplete?: () => void;
};

/**
 * Manages the open and close transition events for a dialog.
 */
export function DialogTransitionEvents(props: DialogTransitionProps) {
  const { children, isEntering, onOpenComplete, onCloseComplete } = props;

  useMountEffect(() => onCloseComplete);
  const prevEntering = usePrevious(isEntering);
  useEffect(() => {
    if (prevEntering && !isEntering) onOpenComplete?.();
  }, [isEntering, onOpenComplete, prevEntering]);

  return children;
}
